import './Splash.css';

/**
 * Branded loading skeleton shown while the CodeMirror + LSP worker bundle mounts.
 * Fades out once the editor signals it is ready (via App.tsx's `onEditorReady`).
 */
export function Splash({ visible }: { visible: boolean }) {
    if (!visible) return null;

    return (
        <div className='splash' aria-busy='true' aria-label='Loading editor…' role='status'>
            <div className='splash-inner'>
                {/* Logo skeleton — mirrors the real logo layout */}
                <div className='splash-logo' aria-hidden='true'>
                    <img
                        src='/logo-light.svg'
                        alt='Nowline'
                        className='splash-logo-img splash-logo-light'
                        width='120'
                        height='55'
                    />
                    <img
                        src='/logo-dark.svg'
                        alt=''
                        className='splash-logo-img splash-logo-dark'
                        aria-hidden='true'
                        width='120'
                        height='55'
                    />
                </div>

                {/* Skeleton bars mimicking the editor + diagram layout */}
                <div className='splash-skeleton' aria-hidden='true'>
                    <div className='splash-pane splash-pane--left'>
                        <div className='splash-bar splash-bar--short' />
                        <div className='splash-bar splash-bar--long' />
                        <div className='splash-bar splash-bar--medium' />
                        <div className='splash-bar splash-bar--long' />
                        <div className='splash-bar splash-bar--short' />
                        <div className='splash-bar splash-bar--medium' />
                        <div className='splash-bar splash-bar--long' />
                    </div>
                    <div className='splash-divider' />
                    <div className='splash-pane splash-pane--right'>
                        <div className='splash-diagram-stub' />
                    </div>
                </div>

                <p className='splash-label'>Loading editor…</p>
            </div>
        </div>
    );
}
